<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Peserta Sertifikasi
      <router-link to="/sertifikasi/data-peserta" class="ml-auto">
        <Button class="btn btn-md btn-dark px-4 py-2 text-white">Kembali</Button>
      </router-link>
    </div>
    <CCardBody>
      <CRow>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-3 pr-xl-4 pr-sm-0">
          <!-- Tabs -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Profile Settings</h5>
            <ul class="list-group list-group-flush">
              <li class="list-group-item">
                <router-link
                  :to="'/sertifikasi/data-peserta-sertifikasi/data-diri/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Diri</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/sertifikasi/data-peserta-sertifikasi/data-keanggotaan/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                  style="color:#2F3AAA;font-weight:bold"
                >Data Anggota</router-link>
              </li>
              <li class="list-group-item">
                <router-link
                  :to="'/sertifikasi/data-peserta-sertifikasi/data-dokumen/'+this.$route.params.id_user"
                  class="nav-link text-dark"
                >Data Dokumen Pendukung</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mt-3">
          <!-- small box -->
          <div class="card border-0">
            <h5 class="card-header text-bold">Data Keanggotaan</h5>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form-data" @submit.prevent="updateDataAnggota">
                    <p class="text-bold" style="font-weight:bold;font-size:20px">Personal</p>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Anggota</label>
                      <div class="col-sm-7">
                        <input
                          type="number"
                          class="form-control"
                          name="text"
                          id="inputEmail"
                          v-model="details.noAnggota"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Tanggal Daftar</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          readonly
                          name="email"
                          v-model="details.tanggalDaftar"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Register Akuntan Negara</label>
                      <div class="col-sm-7">
                        <input
                          type="  number"
                          class="form-control"
                          name="email"
                          id="inputEmail"
                          v-model="details.noRegistrasiAkuntanNegara"
                        />
                        <h6
                          style="color:red;margin-top:5px;font-size:12px"
                        >Diisi bila memiliki No. Reg Akuntan Negara</h6>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Izin Akuntan Publik(khusus AP)</label>
                      <div class="col-sm-7">
                        <input
                          type="number"
                          class="form-control"
                          name="email"
                          v-model="details.noIzinAp"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Tanggal Registrasi Akuntan Publik (Khusus AP)</label>
                      <div class="col-sm-7">
                        <input
                          type="date"
                          class="form-control"
                          name="email"
                          v-model="details.tanggalRegistrasiAp"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Jabatan di Instansi/KAP</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.jabatanAnggota"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="username"
                        class="col-sm-5 col-form-label"
                        style="font-size:13px"
                      >Terdaftar di OJK</label>
                      <div class="col-sm-7">
                        <select
                          name="id_outlet"
                          v-model="details.statusOjk"
                          @change="statusOjkSelect($event)"
                          class="form-control mb-2"
                        >
                          <option value="1" :selected="details.statusOjk == '1'">Ya</option>
                          <option value="0" :selected="details.statusOjk == '0'">Tidak</option>
                        </select>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline mr-5">
                            <input
                              type="checkbox"
                              id="checkboxWarning1"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkBankKonvensional"
                            />
                            <label
                              for="checkboxWarning1"
                              style="font-size:15px;margin-left: 4px;"
                            >Bank Konvensional</label>
                          </div>
                        </div>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline mr-5">
                            <input
                              type="checkbox"
                              id="checkboxWarning1"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkBank"
                            />
                            <label
                              for="checkboxWarning1"
                              style="font-size:15px;margin-left: 4px;"
                            >Bank Syariah</label>
                          </div>
                        </div>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline mr-5">
                            <input
                              type="checkbox"
                              id="checkboxWarning2"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkPasarModal"
                            />
                            <label
                              for="checkboxWarning2"
                              style="font-size:15px;margin-left: 4px;"
                            >Pasar Modal</label>
                          </div>
                        </div>
                        <div class="row ml-1">
                          <div class="icheck-warning d-inline">
                            <input
                              type="checkbox"
                              id="checkboxWarning3"
                              :disabled="details.statusOjk == '0'"
                              v-model="details.statusOjkIknb"
                            />
                            <label
                              for="checkboxWarning3"
                              style="font-size:15px;margin-left: 4px;"
                            >IKNB</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Terdaftar di BPK</label>
                      <div class="col-sm-7">
                        <select name="id_outlet" v-model="details.statusBkp" class="form-control">
                          <option value="1" :selected="details.statusBkp == '1'">Ya</option>
                          <option value="0" :selected="details.statusBkp == '0'">Tidak</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No KTP / Passpor</label>
                      <div class="col-sm-7">
                        <input
                          type="number"
                          v-model="details.noKtp"
                          class="form-control"
                          name="email"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No NPWP Pribadi</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.noNpwp"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No Telepon</label>
                      <div class="col-sm-7">
                        <input
                          type="number"
                          class="form-control"
                          name="email"
                          v-model="details.noTelephone"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Alamat Sesuai KTP</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          v-model="details.alamatKtp"
                          class="form-control"
                          name="email"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Alamat Domisili</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.alamatDomisili"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kecamatan</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.kecamatan"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kota</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          v-model="details.kota"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Provinsi</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          v-model="details.provinsi"
                          name="email"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="inputEmail"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Kode Pos</label>
                      <div class="col-sm-7">
                        <input
                          type="number"
                          class="form-control"
                          v-model="details.kodePos"
                          name="email"
                          id="inputEmail"
                        />
                      </div>
                    </div>
                    <p class="text-bold" style="font-weight:bold;font-size:20px">Instansi</p>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Jenis Instansi</label>
                      <div class="col-sm-7">
                        <select
                          name="id_outlet"
                          v-model="details.jenisInstansi"
                          class="form-control"
                        >
                          <option
                            value="Kantor Akuntan Publik"
                            :selected="details.jenisInstansi == 'Kantor Akuntan Publik'"
                          >Kantor Akuntan Publik</option>
                          <option value="tidak" :selected="details.jenisInstansi == 'tidak'">Tidak</option>
                        </select>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="name"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Nama Instansi</label>
                      <div class="col-sm-7">
                        <input
                          type="text"
                          class="form-control"
                          name="name"
                          id="name"
                          v-model="details.namaInstansi"
                          autofocus="of"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="name"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Alamat Instansi</label>
                      <div class="col-sm-7">
                        <textarea
                          class="form-control"
                          v-model="details.alamatInstansi"
                          name
                          id
                          rows="3"
                        ></textarea>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="no_telp"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >No. Telp. Instansi</label>
                      <div class="col-sm-7">
                        <input
                          type="number"
                          v-model="details.noTelephoneInstansi"
                          class="form-control"
                          name="name"
                          id="no_telp"
                        />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label
                        for="name"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Persetujuan Kewajiban</label>
                      <div class="col-sm-7">
                        <textarea class="form-control" cols='60' rows='8' readonly style="white-space: pre-wrap">
                          Menyatakan bahwa saya bersedia memenuhi kewajiban sesuai ketentuan dalam Anggaran Dasar,
Anggaran Rumah Tangga dan Peraturan yang berlaku di Institut Akuntan Publik Indonesia (IAPI)
berkaitan dengan kewajiban untuk:
1. Melunasi iuran anggota sesuai jangka waktu yang ditetapkan;
2. Mengikuti Pelatihan Profesional Berkelanjutan (PPL) sejumlah Satuan Kredit PPL (SKP) yang
diwajibkan;
3. Mematuhi Standar Profesional Akuntan Publik (SPAP) dan Kode Etik yang berlaku dalam
menjalankan praktik profesi akuntan publik;
4. Menandatangi Pakta Integritas sesuai yang ditetapkan;
5. Menyediakan diri untuk dilakukan reviu mutu;
6. Melaporkan setiap perubahan data dan alamat, serta hal-hal lain terkait dengan pemberian
jasa akuntan publik.
Dalam hal saya tidak memenuhi kewajiban sebagaimana disebutkan di atas, secara otomatis saya
menyetujui untuk diberhentikan sebagai anggota IAPI.
                      </textarea> 
                        <div class="icheck-warning d-inline mt-3">
                          <input
                            type="checkbox"
                            id="checkboxWarning1"
                            v-model="details.statusPernyataanPersetujuanKewajiban"
                          />
                          <label
                            for="checkboxWarning1"
                            style="font-size:12px"
                          >Pernyataan Persetujuan Kewajiban</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mt-3">
                      <label
                        for="username"
                        class="col-sm col-form-label"
                        style="font-size:13px"
                      >Pakta Integritas</label>
                      <div class="col-sm-7">
                        <select name="id_outlet" class="form-control">
                          <option>Akuntan Publik</option>
                        </select>
                        <textarea class="form-control mt-3" name id rows="3" disabled>Lorem ipsum dolor sit amet consectetur adipisicing elit. Error dolor nisi quasi, a unde sequi qui odio tempore voluptas molestias, eligendi eum nesciunt hic quidem laborum mollitia beatae quas quisquam!</textarea>
                        <div class="icheck-warning d-inline mt-5">
                          <input
                            type="checkbox"
                            id="checkboxWarning1"
                            v-model="details.statusPernyataanPersetujuanFaktaIntegritas"
                          />
                          <label
                            for="checkboxWarning1"
                            style="font-size:12px"
                          >Pernyataan Persetujuan Kewajiban</label>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CRow>
      <!-- Modal Verifikasi -->
      <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.statusDataKeanggotaan"
                  />
                  <label class="custom-control-label" for="aktif">Terverifikasi</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.statusDataKeanggotaan"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Verifikasi Data Peserta</h6>          
        </template>
        <template #footer>
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
      <CModal
        title="Modal title"
        :show.sync="modalEmail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postDataEmail">
          <CRow>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Subjek"
                placeholder="Masukkan Subjek"
                v-model="formEmail.subject"
              />
            </CCol>
            <CCol sm="12">
              <CTextarea
                class="font-weight-bold"
                label="Pesan"
                rows="3"
                placeholder="Masukkan isi pesan"
                v-model="formEmail.text"
              />
            </CCol>

            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="customFileLangHTML"
                    @change="fileUpload"
                  />
                  <label
                    class="custom-file-label"
                    for="customFileLangHTML"
                    data-browse="Unggah"
                  >{{ fileName }}</label>
                </div>
                <small class="text-danger">*File harus berupa PDF max 10MB</small>
                <!-- <label class="custom-file-label" for="validatedCustomFile">{{ fileName }}.</label> -->
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>          
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
          <CButton @click="postDataEmail" type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>

<script>
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";

export default {
  name: "KeanggotaanDataDiri",
  data() {
    return {
      fileName: "Pilih File",
      details: {},
      formData: {
        idUser: "",
        statusDataKeanggotaan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      formEmail: {
        to: "",
        subject: "",
        text: "",
        attacment: ""
      },
      no: 1,
      status: false,
      modalVerif: false,
      modalEmail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getData();
    this.formData.idUser = this.$route.params.id_user;
  },

  methods: {
    alertSuccessSend() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Email Telah Terkirim"
      });
    },
    alertErrorSend() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Email Gagal Dikirim",
        icon: "errorr",
        showCancelButton: true
      });
    },
    statusOjkSelect(e) {
      // alert( e.target.value)
      if (e.target.value == "0") {
        this.details.statusOjkBank = false;
        this.details.statusOjkPasarModal = false;
        this.details.statusOjkIknb = false;
        this.details.statusOjkBankKonvensional = false;
      }
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    updateDataAnggota() {
      DataKeanggotaanService.updateDataAnggota(
        this.$route.params.id_user,
        this.details
      )
        .then(response => {
          // comment console console.log(response);
          this.alertSuccess();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Verifikasi"
      });
    },
    getData() {
      DataKeanggotaanService.getDataAnggota(this.$route.params.id_user)
        .then(response => {
          // comment console console.log(response);
          var arr1 = response.data.data[0];
          var arr2 = response.data.data[1];
          this.content = response.data.data;
          var newObject1 = Object.assign({}, this.content[0]);
          var newObject2 = Object.assign({}, this.content[1]);
          var allObject = Object.assign({}, newObject1, newObject2);
          this.details = allObject;

          var tanggalDaftar = this.details.tanggalDaftar.split("-"); // ex input "2010-01-18"
          this.details.tanggalDaftar =
            tanggalDaftar[0] +
            "-" +
            tanggalDaftar[1] +
            "-" +
            tanggalDaftar[2].substr(0, 2);

          var tanggalRegistrasiAp = this.details.tanggalRegistrasiAp.split("-"); // ex input "2010-01-18"
          this.details.tanggalRegistrasiAp =
            tanggalRegistrasiAp[0] +
            "-" +
            tanggalRegistrasiAp[1] +
            "-" +
            tanggalRegistrasiAp[2].substr(0, 2);

          this.formData.statusDataKeanggotaan = this.details.statusKeanggotaan;
          // // comment console console.log("ini data details data driri"+this.formData.statusDataKeanggotaan);

          // comment console console.log("ini email keanggotaan " + response.data.data[2].email);
          var email = response.data.data[2].email;
          this.formEmail.to = email;
        })
        .catch(error => {
          // comment console console.log(error);
        });
      // var arr1 = this.content[0];
      // var arr2 = this.content[1];
      // // comment console console.log("array baru"+arr1)
    },

    postData() {
      DataKeanggotaanService.verifikasiDataKeanggotaan(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.modalVerif = false;
          this.alertVerif();
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    fileUpload(e) {
      this.formEmail.attacment = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
    sendEmail() {
      this.modalEmail = true;
      // this.formEmail = {};
    },
    postDataEmail() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(this.formEmail.to);
      DataKeanggotaanService.postSendMessage(this.formEmail)
        .then(response => {
          // comment console console.log(response);
          this.alertSuccessSend();
          loader.hide();
          this.modalEmail = false;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertErrorSend();
        });
    }
  }
};
</script>
